<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="800">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="info" dark v-bind="attrs" v-on="on">
          View attachments
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5">
          Attachments
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col
              v-for="attachment in attachments"
              :key="attachment.id"
              class="d-flex child-flex"
            >
              <v-img :src="attachment.url" class="grey lighten-2">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    attachments: {
      type: Array,
      default: Array
    }
  },
  data() {
    return {
      dialog: false
    }
  }
}
</script>
